import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
// import {addHealthTracker} from "./HealthTracker.service";
import { Divider } from "primereact/divider";
import logo from '../../../assets/img/LOGO_ID_BLANCO_NARANJA.png';
import useGetDataUser from '../../../CustomHooks/useGetDataUser';
import { addHealthTracker } from './integracion';

const HealthTracker = ({ setShowBienestar }) => {
    const navigate = useNavigate();
    const [date, setDate] = useState('');
    const [mood, setMood] = useState(null);
    const [sleepHours, setSleepHours] = useState(null);
    // const [user, setUser] = useState(null);
    const user = useGetDataUser()
 
    useEffect(() => {
          if(sessionStorage.getItem('token')==null)
          {
            window.location.href = '/';
          }
        }, [])
    // Set current date and user data on component mount
    useEffect(() => {
        // Set current date
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        setDate(formattedDate);
    }, []); // Empty dependency array to run only once on mount

    // Helper function to get initials from name
    const getInitials = (name) => {
        if (!name) return "U";
        return name.split(' ')
            .map(word => word[0])
            .join('')
            .substring(0, 2)
            .toUpperCase();
    };


    // Format date for display (DD/MM/YYYY)
    const formatDateForDisplay = (dateString) => {
        if (!dateString) return '';

        const date = new Date(`${dateString}T00:00:00`);

        return date.toLocaleDateString('es-MX', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timeZone: 'America/Mexico_City'
        });
    };

    const moodOptions = [
        { id: 'molesto', label: 'Molesto', emoji: '😡', value: 1 },
        { id: 'ansioso', label: 'Ansioso', emoji: '😰', value: 2 },
        { id: 'triste', label: 'Triste', emoji: '😢', value: 3 },
        { id: 'tranquilo', label: 'Tranquilo', emoji: '😌', value: 4 },
        { id: 'motivado', label: 'Motivado', emoji: '🙂', value: 5 },
        { id: 'feliz', label: 'Feliz', emoji: '😁', value: 6 }
    ];

    const sleepOptions = [
        { id: 1, label: '< 5' },
        { id: 2, label: '6' },
        { id: 3, label: '7' },
        { id: 4, label: '8' },
        { id: 5, label: '> 9' }
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        const origin = window.location.hostname;
        
        addHealthTracker({
            user: user.ID,
            mood,
            sleepHours,
            origin,
        },setShowBienestar)
    };

    // CSS Styles
    const styles = {
        outerContainer: {
            background: 'linear-gradient(135deg, #1e40af, #3b82f6) ',
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
        },
        container: {
            maxWidth: '600px',
            width: '100%',
            backgroundColor: 'white',
            borderRadius: '16px',
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden',
            border: '1px solid #e2e8f0'
        },
        header: {
            background: '#343c44',
            color: 'white',
            padding: '0.5rem',
            textAlign: 'center',
            fontSize: '1.25rem',
            fontWeight: '700',
            letterSpacing: '0.5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '1rem'
        },
        formContent: {
            padding: '2rem',
            backgroundColor: '#ffffff'
        },
        dateDisplay: {
            textAlign: 'center',
            color: '#4a5568',
            fontSize: '1rem',
            marginBottom: '1.5rem',
            fontWeight: '500'
        },
        userInfo: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '1.5rem',
            gap: '1rem'
        },
        userAvatar: {
            width: '4rem',
            height: '4rem',
            borderRadius: '50%',
            backgroundColor: '#e6f2ff',
            color: '#2c5282',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '700',
            fontSize: '1.5rem',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            marginBottom: '0.75rem'
        },
        sectionTitle: {
            color: '#2d3748',
            fontWeight: '600',
            fontSize: '1rem',
            textAlign: 'center',
            marginBottom: '1.5rem'
        },
        optionsContainer: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.75rem',
            justifyContent: 'center'
        },
        moodOption: {
            position: 'relative'
        },
        hiddenInput: {
            position: 'absolute',
            opacity: 0,
            width: 0,
            height: 0
        },
        moodLabel: (isSelected) => ({
            display: 'flex',
            alignItems: 'center',
            padding: '0.5rem 1rem',
            backgroundColor: isSelected ? '#ff7e23' : 'white',
            color: isSelected ? 'white' : '#4a5568',
            border: `1px solid ${isSelected ? '#ff7e23' : '#cbd5e0'}`,
            borderRadius: '20px',
            cursor: 'pointer',
            fontSize: '0.9rem',
            transition: 'all 0.2s ease',
            boxShadow: isSelected ? '0 4px 6px rgba(67, 56, 202, 0.2)' : '0 2px 4px rgba(0, 0, 0, 0.05)'
        }),
        sleepLabel: (isSelected) => ({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '3.5rem',
            height: '3.5rem',
            backgroundColor: isSelected ? '#ff7e23' : 'white',
            color: isSelected ? 'white' : '#4a5568',
            border: `1px solid ${isSelected ? '#ff7e23' : '#cbd5e0'}`,
            borderRadius: '12px',
            cursor: 'pointer',
            fontSize: '0.9rem',
            transition: 'all 0.2s ease',
            boxShadow: isSelected ? '0 4px 6px rgba(67, 56, 202, 0.2)' : '0 2px 4px rgba(0, 0, 0, 0.05)'
        }),
        actions: {
            display: 'flex',
            justifyContent: 'center',
            marginTop: '2rem'
        },
        saveButton: {
            backgroundColor: '#07b4d4',
            color: 'white',
            fontWeight: '600',
            border: 'none',
            borderRadius: '10px',
            padding: '0.75rem 2rem',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            fontSize: '1rem',
            boxShadow: '0 4px 6px rgba(16, 185, 129, 0.3)',
            transform: 'hover:scale-105'
        }
    };
    function obtenerIniciales(nombreCompleto) {
        const partes = nombreCompleto.trim().split(/\s+/);
        if (partes.length < 2) return '';

        const inicialNombre = partes[0][0].toUpperCase();
        const inicialPrimerApellido = partes[partes.length - 2][0].toUpperCase();

        return inicialNombre + inicialPrimerApellido;
    }
    return (
        <div style={styles.outerContainer}>
            <div style={styles.container}>
                <div style={styles.header}>
                    <img src={logo} width="50px" alt="logo_i+d" />
                    <div>Seguimiento de Bienestar</div>
                </div>

                <form onSubmit={handleSubmit} style={styles.formContent}>
                    <div style={styles.dateDisplay}>
                        {formatDateForDisplay(date)}
                    </div>

                    <div style={styles.userInfo}>
                        {user ? (
                            <>
                                <div style={styles.userAvatar}>{obtenerIniciales(user.NOMBRE)}</div>
                                <div>{user?.NOMBRE}</div>
                            </>
                        ) : (
                            <div>Cargando usuario...</div>
                        )}
                    </div>
                    <Divider></Divider>
                    <div style={{ marginBottom: '1.5rem' }}>
                        <div style={styles.sectionTitle}>¿Cómo me siento hoy?</div>
                        <div style={styles.optionsContainer}>
                            {moodOptions.map((option) => (
                                <div key={option.id} style={styles.moodOption}>
                                    <input
                                        type="radio"
                                        id={`mood-${option.id}`}
                                        name="mood"
                                        value={option.value}
                                        checked={mood === option.value}
                                        onChange={() => setMood(option.value)}
                                        style={styles.hiddenInput}
                                        required
                                    />
                                    <label
                                        htmlFor={`mood-${option.id}`}
                                        style={styles.moodLabel(mood === option.value)}
                                    >
                                        {option.emoji} {option.label}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                    <Divider></Divider>
                    <div>
                        <div style={styles.sectionTitle}>¿Cuántas horas dormí?</div>
                        <div style={styles.optionsContainer}>
                            {sleepOptions.map((option) => (
                                <div key={option.id} style={styles.moodOption}>
                                    <input
                                        type="radio"
                                        id={`sleep-${option.id}`}
                                        name="sleep"
                                        value={option.id}
                                        checked={sleepHours === option.id}
                                        onChange={() => setSleepHours(option.id)}
                                        style={styles.hiddenInput}
                                        required
                                    />
                                    <label
                                        htmlFor={`sleep-${option.id}`}
                                        style={styles.sleepLabel(sleepHours === option.id)}
                                    >
                                        {option.label}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div style={styles.actions}>
                        <button
                            type="submit"
                            style={styles.saveButton}
                        >
                            Guardar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default HealthTracker;